/** `playfair_display` → `Playfair+Display`: a font key of the `fonts` table as a Google Fonts family parameter. */
export function toGoogleFontFamily(fontKey: string): string {
	const family = fontKey.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('_', '+'));

	return family.charAt(0).toUpperCase() + family.slice(1);
}

export function buildGoogleFontStylesheetUrl(fontKey: string): string {
	return `https://fonts.googleapis.com/css2?family=${toGoogleFontFamily(fontKey)}:wght@100;200;300;400;500;600;700;800;900&display=swap`;
}

export function toCssFontFamily(fontKey: string): string {
	return `"${toGoogleFontFamily(fontKey).replaceAll('+', ' ')}", sans-serif`;
}
